<section class="py-14">
  <div class=" flex flex-col items-center justify-center gap-10 lg:gap-16">
    <p class="text-hurrey-24 md:text-hurrey-28 lg:text-hurrey-36 font-bold" id="atomo_featured_on">Digital Pathashala in media</p>

    <div class="logos w-[80%]">

      <div class="logos-slide">
        <a *ngFor="let photo of images" [href]="photo.link_url" target="_blank" rel="noopener noreferrer">
            <img [src]="photo.imgUrl" [alt]="photo.alt">
        </a>
      </div>

      <div class="logos-slide">
        <a *ngFor="let photo of images" [href]="photo.link_url" target="_blank" rel="noopener noreferrer">
            <img [src]="photo.imgUrl" [alt]="photo.alt">
        </a>
      </div>

      <div class="logos-slide">
        <a *ngFor="let photo of images" [href]="photo.link_url" target="_blank" rel="noopener noreferrer">
            <img [src]="photo.imgUrl" [alt]="photo.alt">
        </a>
      </div>

    </div>
  </div>
</section>
